<template>
  <div
    :class="{
      'mb-4': !title,
      'mb-2': title,
      'pl-4 border-left': indent,
      indent
    }"
  >
    <div class="feature-setting" :data-cy="testSelector">
      <div class="label">{{ label }}</div>
      <TextField
        v-if="inputType === 'number'"
        v-model="featureValue"
        data-cy="feature-number"
        type="number"
      />
      <Select
        v-else-if="options.length > 0"
        v-model="featureValue"
        :options="options"
        data-cy="feature-select"
      />
      <ToggleSwitch v-else-if="!title" v-model="featureValue" />
    </div>
    <p class="mb-2">
      {{ description }}
    </p>
    <a v-if="learnMoreLink" :href="learnMoreLink" target="_blank" class="link"
      >Learn More</a
    >
  </div>
</template>

<script>
import TextField from "@/components/TextField.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";

export default {
  components: {
    TextField,
    ToggleSwitch
  },
  props: {
    modelValue: {
      type: [Boolean, String, Number],
      default: false
    },
    inputType: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    learnMoreLink: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    testSelector: {
      type: String,
      default: ""
    },
    title: {
      type: Boolean,
      default: false
    },
    indent: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  computed: {
    featureValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        let value = val;
        if (this.inputType === "number") {
          value = parseFloat(value);
        }
        this.$emit("update:modelValue", value);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.feature-setting {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
}
:not(.indent) + .indent {
  margin-top: -0.5rem;
}
.indent + .indent {
  margin-top: -1.5rem;
  padding-top: 1.5rem;
}
</style>
